import { useMutation, useQueryClient } from '@tanstack/react-query';
import { migrationsApi, migrationKeys } from '@/lib/api';
import type { StartMigrationRequest, MigrationStartedResponse } from '@/types';

interface UseStartMigrationOptions {
  onSuccess?: (result: MigrationStartedResponse) => void;
  onError?: (error: Error) => void;
}

export function useStartMigration(options?: UseStartMigrationOptions) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (data: StartMigrationRequest) => migrationsApi.start(data),
    onSuccess: (migration) => {
      // Invalidate migrations list to show the new migration
      queryClient.invalidateQueries({ queryKey: migrationKeys.lists() });

      // Caller is responsible for navigation (new.tsx navigates to /migrations/$migrationId)
      options?.onSuccess?.(migration);
    },
    onError: (error) => {
      console.error('Failed to start migration:', error);
      options?.onError?.(error instanceof Error ? error : new Error(String(error)));
    },
  });
}
